import _ from "lodash"

export class WhatsappController {
  whatchConnectionInterval = null

  constructor(props) {
    this.whatsappModel = props.models.whatsapp

    _.bindAll(this, ["disconnectWhatsapp","connectWhatsapp","changeWhatsappStatus"])
  }

  getWhatsappConfig() {
    this.whatsappModel.getConfig().then()
  }

  setWhatsappReminderHour(hour) {
    this.whatsappModel.updateReminderHour(hour).then()
  }
  disconnectWhatsapp() {
    this.whatsappModel.disconnect().then()
  }

  connectWhatsapp() {
    this.whatsappModel.connect().then()
  }

  getWhatsappConnection() {
    this.whatsappModel.getConnection().then()
  }

  changeWhatsappStatus(status) {
    if(status) this.whatsappModel.activate().then()
    if(!status) this.whatsappModel.deactivate().then()
  }

  whatchWhatsappConnection() {
    if(this.whatchConnectionInterval) clearInterval(this.whatchConnectionInterval)
    this.whatchConnectionInterval = setInterval(this.getWhatsappConnection.bind(this), 1000)

    return () => clearInterval(this.whatchConnectionInterval)
  }
}
